export default __webpack_public_path__ + "static/media/sc_logo.bf26bc22.svg";